
import axios from "axios";
import DynamicText from "./DynamicText.tsx";
import { useEffect, useRef, useState } from "react";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import LinkHandler from "./LinkHandler.tsx";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import { Environment as environment } from "../../environment.ts";

interface Attribute {
    attributeId: string;
    attributeName: string;
    businessId: string;
}

const AskAddress: React.FC<any> = (data) => {

    const [question, setQuestion] = useState<string>("");
    const { nodes, setNodes, businessId } = useFlowStore();
    const [attributes, setAttributes] = useState<Attribute[]>([]);
    const [requestAttribute, setRequestAttribute] = useState<string>("");
    const [responseAttribute, setResponseAttribute] = useState<string>("");
    const savedRequestAttributeRef = useRef<string | null>(null);
    const savedResponseAttributeRef = useRef<string | null>(null);
    const isFirstRunRef = useRef(true);

    useEffect(() => {
        const node = nodes.find((n) => n.data.id === data.nodeId);
        if (node) {
            const content = (node.data as CanvasNodeData).content.find((c) => c.id === data.subNodeId);
            if (content?.data) {
                const d = content.data as Record<string, string>;
                setQuestion(d.text || "");
                if (d.requestAttribute) {
                    setRequestAttribute(d.requestAttribute);
                    savedRequestAttributeRef.current = d.requestAttribute;
                }
                if (d.responseAttribute) {
                    setResponseAttribute(d.responseAttribute);
                    savedResponseAttributeRef.current = d.responseAttribute;
                }
            }
        }
    }, []);

    useEffect(() => {
        // Skip the very first run: it fires with pristine default state, before the
        // restore effect's setState calls above have flowed through a re-render —
        // writing them here would clobber a just-restored value with blanks/defaults.
        if (isFirstRunRef.current) {
            isFirstRunRef.current = false;
            return;
        }
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        requestAttribute: requestAttribute,
                                        responseAttribute: responseAttribute,
                                        text: question
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });
        setNodes([...(updatedNodes as CanvasNode[])]);
    }, [question, requestAttribute, responseAttribute]);

    const getAllAtributes = () => {
        const payload = {
            businessId: businessId,
            page: 0,
            size: 100
        }
        axios.put(`${environment.baseUrl}/fetch/attribute`, payload).then((response) => {
            const list = response.data.data.data;
            setAttributes(list);
            // Don't clobber a restored selection with the first fetched attribute.
            if (!savedRequestAttributeRef.current && list.length > 0) {
                setRequestAttribute(list[0].attributeName);
            }
            if (!savedResponseAttributeRef.current && list.length > 0) {
                setResponseAttribute(list[0].attributeName);
            }
        }).catch((error) => { });
    }

    useEffect(() => {
        getAllAtributes();
    }, []);

    return (
        <div className="node-body">
            <div>
                <span className="font-label">Question Message</span>
                <DynamicText
                    placeholder="Question message"
                    value={question}
                    setValue={(val) => setQuestion(val)}
                    maxLength={72}
                />
            </div>
            <div>
                <span className="font-label">Select Attribute</span>
                <select value={requestAttribute} onChange={(event) => setRequestAttribute(event.target.value)}>
                    {
                        attributes.map((attr) => {
                            return (<option value={attr.attributeName}>{attr.attributeName}</option>)
                        })
                    }
                </select>
            </div>
            <div>
                <span className="font-label">Select Attribute for Response</span>
                <select value={responseAttribute} onChange={(event) => setResponseAttribute(event.target.value)}>
                    {
                        attributes.map((attr) => {
                            return (<option value={attr.attributeName}>{attr.attributeName}</option>)
                        })
                    }
                </select>
            </div>
            <LinkHandler />
        </div>
    )
}

export default AskAddress;
